'use strict';

var filters = require('./svgFiltersTemplates');
var getters = require('./svgFiltersGetters');

module.exports = {
    getFilter: getters.getFilter.bind(null, filters),
    getFilterNames: getters.getFilterNames.bind(null, filters),
    getFilterDefaults: getters.getFilterDefaults.bind(null, filters),
    isFilterExists: getters.isFilterExists.bind(null, filters)
};
//# sourceMappingURL=svgFilters.js.map